import {Accordion, AccordionSummary, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

const AccordionWrapper = ({children, title}: { children: JSX.Element, title: string }) => {

    const ariaControls = `panel-content-${title}`;
    const ariaId = `panel-header-${title}`;

    return (
        <Accordion defaultExpanded={true}>
            <AccordionSummary
                sx={{
                    backgroundColor: "secondary.main",
                    maxHeight: "3rem !important",
                    minHeight: "3rem !important"
                }}
                expandIcon={<ExpandMoreIcon/>}
                aria-controls={ariaControls}
                id={ariaId}>
                <Typography>{title}</Typography>
            </AccordionSummary>
            {children}
        </Accordion>
    )
}

export default AccordionWrapper